import { computed, toValue } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';

import { queryKeys } from '@/queries/_shared/queryKeys';
import http from '@/services/http';

const MEALS_MENU_PATH = '/meals/menu';
const MEALS_MARK_PATH = '/meals/mark';
const CHILD_CHAT_PATH = '/chat/chat-message';

function unwrapBody(data) {
  if (data && typeof data === 'object' && 'body' in data) return data.body;
  return data;
}

async function fetchMealsMenu(dateTs, type) {
  const params = {
    ts: Math.floor(Number(dateTs || 0) / 1000)
  };
  if (type !== null && type !== undefined) {
    params.type = type;
  }

  const response = await http.get(MEALS_MENU_PATH, {
    params
  });
  return unwrapBody(response.data) || [];
}

async function fetchMealMarks(monthTs) {
  const response = await http.get(MEALS_MARK_PATH, {
    params: {
      ts: Math.floor(Number(monthTs || 0))
    }
  });
  return unwrapBody(response.data) || [];
}

async function fetchChatMessages(page) {
  const response = await http.get(CHILD_CHAT_PATH, {
    params: { page: Number(page || 0) }
  });
  return unwrapBody(response.data) || [];
}

async function sendChatMessage(payload) {
  const response = await http.post(CHILD_CHAT_PATH, payload);
  return unwrapBody(response.data);
}

export function useMealsMenuQuery(dateTs, type, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.childMenu.meals(toValue(dateTs), toValue(type))),
    queryFn: () => fetchMealsMenu(toValue(dateTs), toValue(type)),
    ...options
  });
}

export function useMealMarksQuery(monthTs, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.childMenu.marks(toValue(monthTs))),
    queryFn: () => fetchMealMarks(toValue(monthTs)),
    ...options
  });
}

export function useMenuChatMessagesQuery(page, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.childMenu.chat(toValue(page))),
    queryFn: () => fetchChatMessages(toValue(page)),
    ...options
  });
}

export function useSendMenuChatMessageMutation(options = {}) {
  return useMutation({
    mutationFn: sendChatMessage,
    ...options
  });
}

export { fetchMealsMenu };


